// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"de8eb351","569":"7ce4eb30","743":"3a515f28"}[chunkId] + ".chunk.js";
};